export default class MainTech {
    constructor() {
        this.el = document.querySelector(".no-main-tech__inner");
        if (!this.el) return;

        this.init();
    }

    init() {
        this.initTimeline();
        // this.initDiscover();
        this.initTechLine();
        this.initExpert();
    }

    initTimeline() {
        // 메인 타임라인 (텍스트 & 카드 애니메이션)
        this.tl = gsap.timeline({
            scrollTrigger: {
                pin: true,
                trigger: this.el,
                start: "top top",
                end: "+=1100%", // razor 애니메이션 시간 증가에 맞춰 전체 시간 증가
                scrub: 0.5,
            },
        });
    }

    initExpert() {
        const section = this.el.querySelector(".no-main-tech-red");
        const content = this.el.querySelector(".no-main-tech-red__content");
        const razor = section.querySelector(".no-main-tech-red__razor");
        const shadow = section.querySelector(".no-main-tech-red__shadow");

        this.tl
            .add("redStart")
            .to(
                shadow,
                {
                    y: "-85%",
                    scale: 2.25,
                },
                "<"
            )

            .to(content, {
                y: "0%",
                opacity: 1,
                scale: 1,
            })
            .to(
                razor,
                {
                    y: "-175%",
                    duration: 2.5, // 애니메이션 시간 증가 (기본 1초에서 2.5초로)
                    ease: "power2.inOut",
                },
                "-=0.25"
            )
            .to(
                shadow,
                {
                    y: "-125%",
                },
                "<"
            );
    }

    initTechLine() {
        const section = this.el.querySelector(".no-main-tech-line");
        const items = this.el.querySelectorAll(".no-main-tech-line__item");
        const razor = this.el.querySelector(".no-main-tech-line__razor img");
        const title = this.el.querySelector(".no-section-top");

        // iOS 최적화를 위한 초기 설정
        gsap.set(section, {
            willChange: "clip-path",
            backfaceVisibility: "hidden",
            force3D: true,
        });

        gsap.set(title, {
            y: "30%", // 아래에서 시작
            opacity: 0,
            scale: 0.9,
            willChange: "transform, opacity",
            backfaceVisibility: "hidden",
            force3D: true,
        });

        gsap.set(items, {
            willChange: "transform, opacity",
            backfaceVisibility: "hidden",
            force3D: true,
        });

        this.tl
            .add("techStart")
            // discoverSection이 거의 끝날 때 title이 시작되도록 타이밍 조정
            .to(
                title,
                {
                    y: "0%",
                    opacity: 1,
                    scale: 1,
                    ease: "power2.out",
                    duration: 1.2,
                    force3D: true,
                },
                // "discoverEnd-=0.5" // discoverSection 애니메이션이 끝나기 0.25초 전에 시작
                "-=0.5" // discoverSection 애니메이션이 끝나기 0.25초 전에 시작
            )
            .add("listing"); // items 애니메이션 라벨

        // 모바일과 데스크톱 분리 처리
        ScrollTrigger.matchMedia({
            // 모바일 (768px 이하)
            "(max-width: 768px)": () => {
                // 각 카드를 겹쳐지도록 설정 (아래에서 시작)
                items.forEach((item, index) => {
                    gsap.set(item, {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        opacity: 0, // 모든 카드 초기 상태는 투명
                        zIndex: items.length - index, // 나중 카드가 위에
                        y: "100%", // 아래에서 시작
                        force3D: true,
                    });
                });

                // 각 카드가 하나씩 순차적으로 나타남
                items.forEach((item, index) => {
                    // Fade in: 아래에서 위로 올라오면서 나타남
                    this.tl.to(
                        item,
                        {
                            opacity: 1,
                            y: "25%", // 위로 올라와서 25% 위치에 정착
                            ease: "power2.out",
                            duration: 0.8,
                            force3D: true,
                        },
                        `listing+=${index * 1.5}` // 각 카드마다 1.5초 간격
                    );

                    // Fade out: 위로 사라지면서 투명해짐
                    this.tl.to(
                        item,
                        {
                            opacity: 0,
                            y: "-100%", // 위로 사라짐
                            ease: "power2.in",
                            duration: 0.8,
                            force3D: true,
                        },
                        `listing+=${index * 1.5 + 0.8}` // fade in 후 바로 fade out
                    );
                });

                // 마지막 카드 fade out 완료 후 라벨 추가
                const lastCardIndex = items.length - 1;
                const lastCardFadeOutEnd = lastCardIndex * 1.5 + 0.8 + 0.8; // fade in + fade out duration
                this.tl.add("itemsEnd", `listing+=${lastCardFadeOutEnd}`);

                // razor 애니메이션은 마지막 카드 fade out 후 시작
                this.tl.to(
                    razor,
                    {
                        opacity: 1,
                        scale: 1,
                        ease: "power2.out",
                        duration: 0.8,
                        force3D: true,
                    },
                    "itemsEnd"
                );
            },
            // 데스크톱 (768px 초과)
            "(min-width: 769px)": () => {
                // 기존처럼 3개가 동시에 stagger로 나타남
                this.tl
                    .to(
                        items,
                        {
                            y: "0%",
                            stagger: 0.08,
                            opacity: 1,
                            ease: "power2.out",
                            duration: 0.8,
                            force3D: true,
                        },
                        "listing"
                    )
                    .to(
                        items,
                        {
                            y: "-100%",
                            opacity: 0,
                            stagger: 0.08,
                            ease: "power2.in",
                            duration: 0.8,
                            force3D: true,
                        },
                        "+=0.3"
                    );

                // razor 애니메이션은 기존 타이밍 유지
                this.tl.to(
                    razor,
                    {
                        opacity: 1,
                        scale: 1,
                        ease: "power2.out",
                        duration: 0.8,
                        force3D: true,
                    },
                    "-=0.4"
                );
            },
        });

        // title fade out은 matchMedia 밖에서 처리 (모바일/데스크톱 공통)
        this.tl
            .to(
                title,
                {
                    opacity: 0,
                    scale: 0.8,
                    ease: "power2.in",
                    duration: 0.6,
                    force3D: true,
                },
                "<-=0.5"
            )
            // clipPath 애니메이션을 더 길게 (더 오랫동안 실행)
            .to(
                section,
                {
                    clipPath: "inset(0px 0px 100%)",
                    pointerEvents: "none",
                    ease: "power2.inOut",
                    duration: 2.5, // 더 긴 duration
                    force3D: true,
                },
                "-=0.2"
            );
    }

    initDiscover() {
        const discoverSection = this.el.querySelector(".no-main-tech-discover");
        const title = this.el.querySelector(".no-main-tech-discover__title");
        const imagesWrap = this.el.querySelector(
            ".no-main-tech-discover__images"
        );
        const cards = this.el.querySelectorAll(".no-main-tech-discover__image");
        // const descList = this.el.querySelectorAll(
        //     ".no-main-tech-discover__desc"
        // );
        if (!title || !imagesWrap) return;

        // const firstDesc = descList[0];
        // const secondDesc = descList[1];

        // GPU 가속 활성화
        gsap.set(title, {
            opacity: 1,
            scale: 1,
            force3D: true,
        });

        gsap.set(imagesWrap, {
            opacity: 0,
            scale: 0.4,
            rotateZ: 0,
            force3D: true,
        });

        gsap.set(cards, {
            z: 0,
            force3D: true,
        });

        // gsap.set(descList, {
        //     opacity: 0,
        //     scale: 0.8,
        //     force3D: true,
        // });

        this.tl
            .add("text")
            // 타이틀 페이드아웃
            .to(
                title,
                {
                    scale: 0.9,
                    opacity: 0,
                    ease: "power2.inOut",
                    duration: 1,
                    force3D: true,
                },
                0
            )

            // 첫 번째 설명 표시
            // .to(
            //     firstDesc,
            //     {
            //         opacity: 1,
            //         scale: 1,
            //         ease: "power2.out",
            //         duration: 1,
            //         force3D: true,
            //     },
            //     0.5
            // )

            // // 첫 번째 설명 숨김
            // .to(
            //     firstDesc,
            //     {
            //         opacity: 0,
            //         ease: "power2.in",
            //         duration: 0.8,
            //         force3D: true,
            //     },
            //     1.8
            // )

            // // 두 번째 설명 표시
            // .to(
            //     secondDesc,
            //     {
            //         opacity: 1,
            //         scale: 1,
            //         ease: "power2.out",
            //         duration: 1,
            //         force3D: true,
            //     },
            //     2
            // )

            // 카드 깊이 효과
            .to(
                [cards[0], cards[2]],
                {
                    z: 80,
                    ease: "power2.inOut",
                    duration: 1.5,
                    force3D: true,
                },
                2.5
            )

            // 두 번째 설명 숨김
            // .to(
            //     secondDesc,
            //     {
            //         opacity: 0,
            //         ease: "power2.in",
            //         duration: 0.8,
            //         force3D: true,
            //     },
            //     3.5
            // )
            .add("images", 0.25)
            .to(
                imagesWrap,
                {
                    opacity: 1,
                    scale: 3,
                    rotateZ: 180,
                    ease: "power2.in", // 처음에는 느리다가 나중에 빨라지는 효과
                    duration: 5, // 애니메이션 시간을 더 길게
                    force3D: true,
                },
                "images"
            )
            .add("imagesEnd")
            .to(
                discoverSection,
                {
                    opacity: 0,
                    pointerEvents: "none",
                    ease: "power2.in",
                    duration: 1.2, // 더 부드러운 페이드아웃
                    force3D: true,
                },
                "-=0.5"
            )
            .add("discoverEnd"); // discoverSection 애니메이션 끝 라벨 추가
    }
}
